import { getRouteApi, useNavigate } from '@tanstack/react-router';
import { docPageModes } from '~/types';
import { useEffect, useState } from 'react';
import { useDocumentCache } from '~/atoms/document/useDocumentCache';
const routeApi = getRouteApi('/_authLayout/documents/fund/$fundId');
/**
 * utility hook to simplify the handling of the documents url params for the documents page
 */
export const useDocumentsUrlParams = () => {
  const navigate = useNavigate({});
  const { mode, docId, docIds } = routeApi.useSearch();
  const [isDocumentOverviewDialogVisible, setIsDocumentOverviewDialogVisible] =
    useState<boolean>(false);
  const [isDocumentCompareDialogVisible, setIsDocumentCompareDialogVisible] =
    useState<boolean>(false);
  const [isEditDocumentDialogVisible, setIsEditDocumentDialogVisible] =
    useState<boolean>(false);
  const [activeDocumentId, setActiveDocumentId] = useState<
    string | undefined
  >();
  const [activeDocumentName, setActiveDocumentName] = useState<
    string | undefined
  >();
  const { getDocument } = useDocumentCache();
  const showDocumentOverview = (documentId: string) => {
    navigate({
      from: '/documents/fund/$fundId',
      search: () => ({
        mode: 'docOverview' as docPageModes,
        docId: documentId,
      }),
    });
  };
  const showEditDocumentDialog = (documentId: string) => {
    navigate({
      from: '/documents/fund/$fundId',
      search: () => ({
        mode: 'editDocument' as docPageModes,
        docId: documentId,
      }),
    });
  };
  const showDocumentsCompare = () => {
    navigate({
      from: '/documents/fund/$fundId',
      search: () => ({
        mode: 'docCompare' as docPageModes,
        docId: undefined,
      }),
    });
  };
  const hideDocumentOverview = () => {
    navigate({
      from: '/documents/fund/$fundId',
      search: () => ({
        mode: 'table' as docPageModes,
        docId: undefined,
      }),
    });
  };
  const hideDocumentCompare = () => {
    navigate({
      from: '/documents/fund/$fundId',
      search: () => ({
        mode: 'table' as docPageModes,
        docId: undefined,
      }),
    });
  };
  const hideEditDocumentDialog = () => {
    navigate({
      from: '/documents/fund/$fundId',
      search: () => ({
        mode: 'table' as docPageModes,
        docId: undefined,
      }),
    });
  };

  useEffect(() => {
    if (mode === 'docOverview' && docId) {
      setIsDocumentOverviewDialogVisible(true);
      setActiveDocumentId(docId);
      if (docId) {
        getDocument(docId).then((doc) => {
          setActiveDocumentName(doc?.originalName);
        });
      }
    }
    if (mode === 'table') {
      setIsDocumentOverviewDialogVisible(false);
      setIsDocumentCompareDialogVisible(false);
      setIsEditDocumentDialogVisible(false);
    }
    if (mode === 'docCompare') {
      setIsDocumentOverviewDialogVisible(false);
      setIsEditDocumentDialogVisible(false);
      setIsDocumentCompareDialogVisible(true);
    }
    if (mode === 'editDocument' && docId) {
      setIsEditDocumentDialogVisible(true);
      setIsDocumentOverviewDialogVisible(false);
      setIsDocumentCompareDialogVisible(false);
      setActiveDocumentId(docId);
    }
  }, [mode, docId, docIds, getDocument]);

  return {
    isDocumentOverviewDialogVisible,
    isDocumentCompareDialogVisible,
    isEditDocumentDialogVisible,
    showDocumentOverview,
    showEditDocumentDialog,
    activeDocumentId,
    activeDocumentName,
    hideDocumentOverview,
    hideDocumentCompare,
    hideEditDocumentDialog,
    showDocumentsCompare,
  };
};
